export default __webpack_public_path__ + "static/media/3.a4b6bf6e.png";